module.exports = __webpack_public_path__ + "img/gmail-icon-black.36824880.svg";